import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";

import { version } from "../../config";
import Link from "../../components/Link";
// Style
import Styled from "./style";

// Redux
import { connect } from "react-redux";
// import * as actions from "../../redux/actions";

class Footer extends Component {
  _isLogin = () => {
    if (this.props.isLoggedIn) {
      return true;
    } else {
      return false;
    }
  };
  render() {
    return (
      <Styled>
        <footer>
          <section id="sitemap">
            <div className="container">
              <Row>
                <Col md={3}>
                  <div className="logo-container">
                    <img
                      src={require("../../assets/img/lolol_logo_with_slogan.png")}
                      alt=""
                      className="img-responsive logo"
                    />
                  </div>
                </Col>
                <Col md={6} className="logo-container">
                  <h3 className="uppercase">NAVIGATE</h3>
                  <ul className="navigate">
                    {/* <li className="">
                    <Link to="/register-merchant">Register as MERCHANT</Link>
                  </li> */}
                    {!this._isLogin() ? (
                      <li className="">
                        <Link to="/register">Register as CONSUMER</Link>
                      </li>
                    ) : null}

                    <li className="">
                      <Link to="/merchant-interest-form">
                        Register as MERCHANT
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                    <li className="">
                      <Link to="/terms-and-conditions">Term of Use</Link>
                    </li>
                    <li className="">
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li className="">
                      <Link to="/location-based-services-policy">
                        Location - Based Service Policy
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/refund-return-policy">
                        Refund and Return Policy
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/merchant-terms-of-services">
                        Merchant Terms of Service
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/faq">Frequently Asked Questions (FAQ)</Link>
                    </li>
                  </ul>
                  {/* <ul> */}
                  {/* <li className="">
                    <a href="/">Find Restaurant</a>
                  </li>
                  <li className="">
                    <a href="/">News Blog</a>
                  </li> */}
                  {/* <li className="">
                    <a href="/contact-us">Contact Us</a>
                  </li> */}
                  {/* </ul> */}
                </Col>
                {/* <Col xl={3} md={3} id="newsletter">
                  <h3 className="uppercase">ABOUT US</h3>
                  <p className="mb-5 text-justify pr-5">
                    LOLOL is a lifestyle platform that provides you amazing
                    sales and promotions on various products and services that
                    can be enjoyed with instant payment...
                    <Link to="/about-us" className="view-more">
                      View More
                    </Link>
                  </p>
                  <h3>OUR HOTLINE</h3>
                  <p className="mb-5">
                    <a
                      href="tel:+60329359717"
                      //   href="https://wa.me/60139287917"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +603-29359717
                      {/* +6013 928 7917
                    </a>{" "}
                  </p>
                </Col> */}
                <Col md={3} className="text-center">
                  <h3 className="uppercase">GET THE APP</h3>
                  <div className="app">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.lolol.userApp"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={require("../../assets/img/button-google.png")}
                        alt="button-google"
                      />
                    </a>
                    <a
                      href="https://itunes.apple.com/my/app/lolol-pay-less-get-more/id1440552007?mt=8"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={require("../../assets/img/button-apple.png")}
                        alt="button-apple"
                      />
                    </a>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div id="social_footer">
                    {this.props.hotline_no && this.props.hotline_no !== null ? (
                      <React.Fragment>
                        <h3 className="mb-1">OUR HOTLINE</h3>
                        <p className="mb-3">
                          <a
                            href={"tel:+" + this.props.hotline_no}
                            // href="tel:+60329359717"
                            // href="https://wa.me/60139287917"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {"+" + this.props.hotline_no}
                            {/* +6016 299 9381 */}
                            {/* +603-29359717 */}
                            {/* +6013 928 7917 */}
                          </a>
                        </p>
                      </React.Fragment>
                    ) : null}
                    {this.props.whatsapp_no &&
                    this.props.whatsapp_no !== null ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <a
                          href={
                            "https://wa.me/+" +
                            this.props.whatsapp_no.replace("+", "")
                          }
                          // href="https://lololivechat.wasap.my/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            fontSize: "15px",

                            letterSpacing: "0.04em",
                          }}
                        >
                          <div
                            className="mb-3"
                            style={{
                              padding: "12px",
                              paddingLeft: "15px",
                              paddingRight: "15px",
                              backgroundColor: "rgb(37, 211, 102)",
                              color: "rgb(255, 255, 255)",
                              width: 200,
                              borderRadius: "4px",
                            }}
                          >
                            <svg
                              height="24"
                              viewBox="0 0 18 18"
                              width="24"
                              style={{
                                marginRight: "8px",
                                width: "24px",
                                height: "24px",
                              }}
                            >
                              <path
                                d="m13.1460703 10.7880226c-.223174-.111869-1.3203713-.6528056-1.5249582-.7274708-.2045869-.07462226-.3533696-.11191195-.5021523.1118691-.1487827.2238669-.576458.7275566-.7066963.8768441-.1301528.1491588-.2603483.1679109-.48347953.055956-.22321685-.1119549-.94233316-.3480514-1.79477143-1.10993685-.66348341-.59290179-1.11137325-1.3251357-1.24156881-1.54904549-.13015272-.22382396-.01383327-.34483308.09790364-.45635886.10038762-.10019727.22317402-.26119948.33473962-.39173485.11160843-.13057828.14878269-.22390978.22317403-.37302563.07439134-.1492875.03721709-.27986578-.01858713-.39177776-.05580421-.11191198-.50215227-1.21262297-.68810921-1.66039962-.18116026-.43593322-.36514714-.37688763-.50215227-.38383922-.13002424-.00647957-.27897824-.00785272-.42771809-.00785272-.14878269 0-.39058667.05595599-.59513074.27977995-.2045869.22390979-.78113051.76488922-.78113051 1.86551438 0 1.10066807.79971764 2.16391771.91132606 2.3131623.1115656.14928749 1.57369596 2.40786697 3.81250276 3.37649777.53247413.2303893.94820051.368005 1.27227611.4709915.5346583.170271 1.0211786.1462408 1.4056837.0886542.4287888-.0641949 1.3204142-.5409365 1.506414-1.0632496.1859569-.522399.1859569-.9700898.1301527-1.0633355-.0557613-.0932886-.204544-.1492875-.4277181-.2612424m-4.14600587 5.5244774h-.00300481c-1.33516282-.0005109-2.64474189-.3562691-3.78721098-1.0287014l-.27167714-.159955-2.8162303.7327188.75167297-2.7233638-.17689705-.279208c-.74484778-1.1750323-1.13821944-2.5330527-1.137662-3.9275601.00163177-4.06908001 3.33962468-7.3795555 7.44397118-7.3795555 1.9874627.0006812 3.8557205.76937603 5.2605948 2.16435172 1.4048313 1.39493311 2.178053 3.24920981 2.1773238 5.22112173-.0016746 4.06942065-3.3396676 7.38015155-7.44088047 7.38015155m6.37738627-13.69672097c-1.6920847-1.68595901-3.9423532-2.61483813-6.33989212-2.61577903-4.93994185 0-8.96046398 4.00099317-8.96244076 8.91880487-.00064461 1.57206773.41203067 3.10649953 1.19634147 4.45921003l-1.27145929 4.6219851 4.75107297-1.2403588c1.30906117.7105911 2.78292602 1.0851536 4.2829188 1.0856668h.00365276.00004297c4.9394262 0 8.9603351-4.0014209 8.9623125-8.91936087.0009018-2.38324918-.9304646-4.62425185-2.6225493-6.3101681"
                                fill="#FFF"
                                fill-rule="evenodd"
                              ></path>
                            </svg>
                            WhatsApp LOLOL!
                          </div>
                        </a>
                      </div>
                    ) : null}
                    <ul>
                      <li>
                        <a
                          href="https://www.facebook.com/LOLOLofficial/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="facebook"
                        >
                          <i className="fa fa-facebook" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/lololfooddelivery.my/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="instagram"
                        >
                          <i className="fa fa-instagram" />
                        </a>
                      </li>
                      {/* <li>
                        <a href="/#" className="twitter">
                          <i className="fa fa-twitter" />
                        </a>
                      </li> */}
                      <li>
                        <a
                          //   href="https://www.youtube.com/channel/UCgB4kJ6YQ3HXcSQk7m0Ytvg"
                          href="https://www.youtube.com/channel/UCjijULO0FSbTMb2bW50SnVA"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="youtube"
                        >
                          <i className="fa fa-youtube-play" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
          </section>
          <section className="copyright">
            <Container>
              © 2021 LOLOL Sdn Bhd. All Rights Reserved. (V{version})
            </Container>
          </section>
        </footer>
      </Styled>
    );
  }
}

Footer.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.Auth.isLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
